<div class="container" *ngIf="showEmail">
    <form [formGroup]="form" (submit)="submit()" class="formulaire">
        <h5 class="text-center">Changer de mot de passe</h5>
        <div class="row mb-2">
            <input class="forminput" type="email" placeholder="adresse email" formControlName="email">
        </div>
        <div *ngIf="form.controls['email'].invalid && (form.controls['email'].dirty || form.controls['email'].touched)" class="alert">
            <label *ngIf="form.controls['email'].errors.required || form.controls['email'].hasError('email')" class="text-danger">
                ⚠️ Entrer une adresse mail valide
            </label>
        </div>
        <div class="row mb-2">
            <button class="btnsubmit" type="submit" [disabled]="!form.valid">Envoyer</button>
        </div>
        <div class="row mb-2" *ngIf="emailSubmit">
            <p *ngIf="emailsend"> Un email vous a été envoyé avec un lien pour changer de mot de passe,
                vous pouvez quitter cette page.
            </p>
            <p *ngIf="!emailsend">⚠️ Une erreur est survenue veuillez verifié l'adresse email</p>
        </div>
    </form>
</div>
<div class="container" *ngIf="!showEmail">
    <form class="formulaire" [formGroup]="passwordForm" (submit)="submitPassword()">   
        <h5 class="text-center">Changer de mot de passe</h5>
        <div class="row mb-2">
            <input class="forminput" type="password" placeholder="Nouveau mot de passe" formControlName="password">
        </div>
        <div *ngIf="passwordForm.controls['password'].invalid && (passwordForm.controls['password'].dirty || passwordForm.controls['password'].touched)" class="alert">
            <label
            class="text-danger"
            *ngIf="passwordForm.controls['password'].hasError('hasNumber') 
            ||passwordForm.controls['password'].hasError('hasCapitalCase')
            ||passwordForm.controls['password'].hasError('required')
            ||passwordForm.controls['password'].hasError('hasSmallCase')
            ||passwordForm.controls['password'].hasError('minlenght')"
            >
            ⚠️ Le mot de passe doit comporter au minimum 8 caractères, dont au moins une majuscule et une minuscule et un chiffre. 
            </label>
        </div>
        <div class="row mb-2">
            <input class="forminput" type="password" placeholder="Confirmer mot de passe" formControlName="confirmPassword">
        </div>
        <div class="row mb-2">
            <button class="btnsubmit" type="submit" [disabled]="!passwordForm.valid">Envoyer</button>
        </div>
    </form>
</div>